// extracted by mini-css-extract-plugin
export var actualiteCategorie = "newsletter-module--actualite-categorie--72867";
export var actualiteContainer = "newsletter-module--actualiteContainer--feb34";
export var actualiteContainerFirst = "newsletter-module--actualiteContainerFirst--ea135";
export var actualiteInfos = "newsletter-module--actualite-infos--759f8";
export var actualiteResume = "newsletter-module--actualite-resume--234da";
export var actualiteTitle = "newsletter-module--actualite-title--af81b";
export var eventsContainer = "newsletter-module--events-container--8260a";
export var eventsItem = "newsletter-module--events-item--7a8c1";
export var eventsItemDate = "newsletter-module--events-item-date--221d4";
export var eventsItemDateFrom = "newsletter-module--events-item-date-from--7ad70";
export var eventsItemDateTo = "newsletter-module--events-item-date-to--44ec0";
export var eventsItemImg = "newsletter-module--events-item-img--60257";
export var eventsItemTaxo = "newsletter-module--events-item-taxo--a0a92";
export var eventsItemTitle = "newsletter-module--events-item-title--0cdfa";
export var listActualitesContainer = "newsletter-module--list-actualites-container--5d8b9";
export var newsletterContainer = "newsletter-module--newsletter-container--2d522";
export var newsletterContent = "newsletter-module--newsletter-content--dd4a1";
export var newsletterDate = "newsletter-module--newsletter-date--38180";
export var newsletterTitle = "newsletter-module--newsletter-title--7c4f9";